import { createContext, useContext, useEffect, useState } from 'react'

export interface ModalContextProps {
  registerModal: (modalName: string, component: any) => void
  closeModal: () => void
  openModal: (open: string) => void
}

const ModalContextForHooks = createContext<ModalContextProps>(undefined as any)

export const useModals = () => useContext(ModalContextForHooks)

export enum MODALS {}

export const ModalContextForHooksProvider = ({
  children,
}: {
  children: any
}) => {
  const [modalName, setModalName] = useState<string>('')
  const [modals, setModals] = useState<any>([])

  const registerModal = (modalName: string, Component: any) => {
    if (!modals[modalName]) {
      setModals({
        ...modals,
        [modalName]: Component,
      })
    }
  }

  const openModal = (modalName: string) => {
    setModalName(modalName)
  }
  const closeModal = () => {
    setModalName('')
  }

  return (
    <ModalContextForHooks.Provider
      value={{ registerModal, openModal, closeModal }}
    >
      {modalName && modals[modalName]}
      {children}
    </ModalContextForHooks.Provider>
  )
}

export const ModalConsumer = () => {
  const { registerModal, closeModal } = useModals()

  useEffect(() => {}, [registerModal, closeModal])

  return null
}
